import { useApp } from '@/hooks/use-app-context';
import { PasswordRecoveryView } from '@/features/password-recovery/PasswordRecoveryView';
import { usePasswordRecovery } from '@/features/password-recovery/use-password-recovery';

export default function ForgotPassword() {
  const { t } = useApp();
  const recovery = usePasswordRecovery(t);

  return <PasswordRecoveryView t={t} recovery={recovery} />;
}
